import React, { useEffect, useState } from 'react'
import { Container, FormGroupCustom, FormLabelCustom, InputDateFinal, InputDateInicial } from './style'
import { Form } from 'react-bootstrap'
import { getOrganDataList } from '../../../../services/organ'
import { cpfMask } from '../../../../utils/cpfFormat'
import MultiSelect from '../../../../Components/MultiSelect'

const Filters = ({ setFilters, filters, dataAtendentes, sectors }: any) => {
  const [orgaoList, setOrgaoList] = useState<any>(null);
  const [loadingOrgao, setLoadingOrgao] = useState<boolean>(false);
  const [orgaoAll, setOrgaoAll] = useState<any>();

  const handleGetById = (slug: string, items: any) => {
    if (slug) {
      return items.filter((item) => item.slug === slug);
    }
  }

  const setOrgaoValueFormatted = (values) => {
    if (values) {
      let orgaoOptions = values.map((value) => ({
        label: value.nome,
        value: value.slug,
      }));
      setOrgaoList(orgaoOptions);
    }
  }

  useEffect(() => {
    const getOrgans = async () => {
      const tokenSSO: string | null = localStorage.getItem('gov_access_token');
      try {
        setLoadingOrgao(true);
        const { data } = await getOrganDataList(tokenSSO);
        if (data) {
          setOrgaoValueFormatted(data);
          setOrgaoAll(data);
        }

      } catch (error) {
        console.log(error);

      } finally {
        setLoadingOrgao(false);
      }
    };
    getOrgans();
  }, []);

  const optionsSectors = sectors?.map(sector => ({
    value: sector.sigla,
    label: sector.nome,
  }));

  const booleanOptionsStatus = [
    { value: 'Solicitado', label: 'Solicitado' },
    { value: 'Em Andamento', label: 'Em Andamento' },
    { value: 'Finalizado', label: 'Finalizado' },
    { value: 'Cancelado pelo atendente', label: 'Cancelado pelo Atendente' },
    { value: 'Cancelado pelo usuário', label: 'Cancelado pelo Usuário' },
    { value: 'Restituído', label: 'Restituído' },
    { value: 'Encaminhado', label: 'Encaminhado' },
  ];

  const handleChangeDataInicial = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    let value = e.target.value;
    setFilters({
      ...filters,
      createdData: value
    })
  }

  const handleChangeStatus = (selectedOptions) => {
    setFilters({
      ...filters,
      status: selectedOptions || [],
    });
  }

  const handleChangeSetor = (selectedOptions) => {
    setFilters({
      ...filters,
      setor: selectedOptions || [],
    });
  }

  return (
    <Container>
      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Status</FormLabelCustom>
        <MultiSelect
          options={booleanOptionsStatus}
          value={filters?.status}
          onChange={handleChangeStatus}
          placeholder="Selecione um ou mais status."
        />
      </FormGroupCustom>

      <FormGroupCustom>
        <FormLabelCustom>
          Protocolo
        </FormLabelCustom>
        <Form.Control
          type="Protocolo"
          required
          value={filters.protocol}
          onChange={(event) => setFilters({ ...filters, protocol: event.target.value })}
        />
      </FormGroupCustom>

      <FormGroupCustom>
        <FormLabelCustom>
          CPF do solicitante
        </FormLabelCustom>
        <Form.Control
          type="cpf"
          required
          value={filters.cpf ? filters.cpf : ''}
          onChange={(event) => setFilters({ ...filters, cpf: cpfMask(event.target.value) })}
        />
      </FormGroupCustom>

      {/*  <FormGroupCustom>
        <FormLabelCustom>
          Órgão
        </FormLabelCustom>
        <SelectWithSearch
          name='orgao'
          options={orgaoList}
          isDisabled={!orgaoList || loadingOrgao}
          value={filters.orgao}
          onChange={handleSelectOrgao}
          placeholder="Selecione ou digite o nome do órgão"
        />
      </FormGroupCustom> */}

      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Setor</FormLabelCustom>
        <MultiSelect
          options={optionsSectors}
          value={filters?.setor}
          onChange={handleChangeSetor}
          placeholder="Selecione um ou mais Setores."
        />
      </FormGroupCustom>

      {/*  <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Atendentes</FormLabelCustom>
        <MultiSelect
          options={optionsAtendente}
          value={filters?.atendente}
          onChange={handleChange}
          placeholder="Select attendants..."
        />
      </FormGroupCustom> */}

      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Data início</FormLabelCustom>
        <InputDateInicial
          style={{ width: "auto" }}
          type={"date"}
          placeholder="Data inicial"
          value={filters.dataInicio}
          disabled={false}
          onChange={(event) => setFilters({ ...filters, dataInicio: event.target.value })}
        />
      </FormGroupCustom>
      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Data Fim</FormLabelCustom>
        <InputDateFinal
          style={{ width: "auto" }}
          type={"date"}
          placeholder="Data final"
          value={filters.dataFim}
          disabled={false}
          onChange={(event) => setFilters({ ...filters, dataFim: event.target.value })}
        />
      </FormGroupCustom>

      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Data da solicitação</FormLabelCustom>
        <InputDateInicial
          type={"date"}
          placeholder="Data de criação"
          value={filters.createdData}
          disabled={false}
          onChange={handleChangeDataInicial}
        />
      </FormGroupCustom>
    </Container>
  )
}

export default Filters